{
  "toast": {
    "analyticsRefreshed": "Analytics refreshed",
    "ruleSaved": "Rule saved",
    "ruleRemoved": "Rule removed",
    "postRescheduled": "Post rescheduled",
    "campaignCreated": "Campaign created",
    "submittedForApproval": "Submitted for approval",
    "channelConnectedSuccessfully": "Channel connected successfully",
    "channelAddedFinishConnectionBelow": "Channel added — finish connection below",
    "connectedDemoMode": "Connected (demo mode)",
    "disconnected": "Disconnected",
    "reconnectStarted": "Reconnect started",
    "replyPublished": "Reply published",
    "commentResolved": "Comment resolved",
    "assigned": "Assigned",
    "replySent": "Reply sent",
    "conversationAssigned": "Conversation assigned",
    "escalatedDeskTicketWorkflowTriggered": "Escalated — Desk ticket workflow triggered",
    "noteSavedForYourTeam": "Note saved for your team",
    "savedReplyAdded": "Saved reply added",
    "inboundMessageSimulated": "Inbound message simulated",
    "published": "Published",
    "connectedInDemoModeRunTestsBelow": "Connected in demo mode — run tests below",
    "allTestsPassed": "All tests passed",
    "diagnosticsComplete": "Diagnostics complete",
    "tokenRefreshAttempted": "Token refresh attempted",
    "notificationPreferencesSaved": "Notification preferences saved",
    "keywordAdded": "Keyword added",
    "folderCreated": "Folder created",
    "uploadComplete": "Upload complete",
    "assetRemoved": "Asset removed",
    "publishRetryCompleted": "Publish retry completed",
    "publishedToConnectedChannels": "Published to connected channels",
    "reviewIngestedSimulatedWebhook": "Review ingested (simulated webhook)",
    "brandCreated": "Brand created",
    "competitorAdded": "Competitor added",
    "integrationCredentialsSaved": "Integration credentials saved",
    "connectionFlowReset": "Setup form reset",
    "reportExported": "{{reportType}} exported",
    "leadCreated": "Lead #{{id}} created",
    "noteAdded": "Note added",
    "tagCreated": "Tag created",
    "conversationEscalated": "Conversation escalated",
    "scheduled": "Scheduled",
    "workflowSaved": "Workflow saved",
    "connectionValidated": "Connection validated",
    "postScheduled": "Post scheduled"
  },
  "errors": {
    "analyticsUnavailable": "Analytics unavailable",
    "syncFailed": "Sync failed",
    "failedToLoadDashboard": "Could not load dashboard metrics. Try refreshing or check your permissions.",
    "exportFailed": "Export failed",
    "failedToLoadAutomationRules": "Failed to load automation rules",
    "failedToSaveRule": "Failed to save rule",
    "failedToDeleteRule": "Failed to delete rule",
    "failedToUpdateRule": "Failed to update rule",
    "calendarUnavailableOnCurrentPlan": "Calendar unavailable on current plan",
    "rescheduleFailed": "Reschedule failed",
    "failedToCreateCampaign": "Failed to create campaign",
    "approvalSubmitFailed": "Approval submit failed",
    "accountNameIsRequired": "Account name is required",
    "couldNotAddChannel": "Could not add channel",
    "connectionFailedSeeSetupGuideForThisNetwork": "Connection failed — see setup guide for this network",
    "disconnectFailed": "Disconnect failed",
    "reconnectFailed": "Reconnect failed",
    "failedToLoadComments": "Failed to load comments",
    "replyFailed": "Reply failed",
    "resolveFailed": "Resolve failed",
    "assignFailed": "Assign failed",
    "couldNotCreateCrmLead": "Could not create CRM lead",
    "selectAConnectedAccount": "Select a connected account",
    "recipientPhoneRequired": "Enter recipient phone in E.164 format (no +) for WhatsApp test sends",
    "recipientPhoneInvalid": "Phone must be country code + number (e.g. 919876543210), digits only",
    "failedToLoadInbox": "Failed to load inbox",
    "failedToLoadMessages": "Failed to load messages",
    "failedToSendMessage": "Failed to send message",
    "assignmentFailed": "Assignment failed",
    "escalationFailed": "Escalation failed",
    "couldNotSaveNote": "Could not save note",
    "simulationFailed": "Simulation failed",
    "failedToLoadPosts": "Failed to load posts",
    "publishFailed": "Publish failed",
    "connectChannelFirst": "Connect channel first",
    "connectionFailed": "Connection failed",
    "testsFailed": "Tests failed",
    "failedToLoadAccounts": "Failed to load accounts",
    "failedToLoadConnectionCenter": "Failed to load connection center",
    "diagnosticsFailed": "Diagnostics failed",
    "tokenRefreshFailedReconnectChannel": "Token refresh failed — reconnect channel",
    "reconnectChannelPrompt": "This channel needs to be reconnected to continue.",
    "addKeywordFailed": "Add keyword failed",
    "failedToLoadFolders": "Failed to load folders",
    "failedToCreateFolder": "Failed to create folder",
    "uploadFailed": "Upload failed",
    "deleteFailed": "Delete failed",
    "contentAndAtLeastOnePlatformRequired": "Content and at least one platform required",
    "createFailed": "Create failed",
    "mediaFileTooLarge": "Media file is too large (max 100 MB)",
    "scheduleMustBeFuture": "Schedule time must be in the future",
    "publishFailedUseRetryAfterFixingChannelTokens": "Publish failed — use Retry after fixing channel tokens",
    "retryFailedOpenConnectionCenterToRefreshTokens": "Retry failed — open Connection Center to refresh tokens",
    "contentIsRequired": "Content is required",
    "selectAtLeastOneConnectedChannel": "Select at least one connected channel",
    "selectAConnectedChannel": "Select a connected channel",
    "failedToReply": "Failed to reply",
    "failedToCreateBrand": "Failed to create brand",
    "failedToAddKeyword": "Failed to add keyword",
    "failedToAddCompetitor": "Failed to add competitor",
    "failedToSaveIntegration": "Failed to save integration",
    "resetConnectionFailed": "Failed to reset connection setup",
    "failedToLoadTeam": "Failed to load team",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToLoadCrmLeads": "Failed to load CRM leads",
    "listeningUnavailableOnCurrentPlan": "Listening unavailable on current plan",
    "failedToLoadMediaLibrary": "Failed to load media library",
    "failedToLoadPublishing": "Failed to load publishing",
    "failedToLoadReviews": "Failed to load reviews",
    "failedToAddNote": "Failed to add note",
    "failedToCreateTag": "Failed to create tag",
    "failedToUpdateFavorite": "Failed to update favorite",
    "couldNotLoadMediaAsset": "Could not load media asset",
    "failedToSaveWorkflow": "Failed to save workflow",
    "failedToSavePreferences": "Failed to save preferences",
    "failedToStartAuthorization": "Failed to start authorization",
    "validationFailed": "Validation failed",
    "failedToUpdateConnectionProgress": "Failed to update connection progress"
  },
  "pages": {
    "followersAudience": "Followers / audience",
    "reach": "Reach",
    "engagement": "Engagement",
    "messages": "Messages",
    "responseTime": "Response time",
    "clicks": "Clicks",
    "impressions": "Impressions",
    "leadAttribution": "Lead attribution",
    "liveMonitoring": "Live monitoring",
    "topContent": "Top content",
    "analyticsCenter": "Analytics Center",
    "rankedByEngagementFromSyncedSnapshots": "Ranked by engagement from synced snapshots",
    "crossPlatformPerformanceExportsAndScheduled": "Cross-platform performance, exports, and scheduled reporting",
    "automationCenter": "Automation Center",
    "autoRepliesAssignmentLeadRoutingReview": "Auto-replies, assignment, lead routing, review routing, escalation, and sentiment rules — stored securely per organization",
    "contentCalendar": "Content Calendar",
    "dragPostsBetweenDaysToReschedule": "Drag posts between days to reschedule — auto-publish runs every 30 seconds",
    "socialCampaigns": "Social Campaigns",
    "crossChannelCampaignsLinkedToMarketing": "Cross-channel campaigns linked to Marketing — no duplicate campaign engine",
    "connectedChannels": "Connected channels",
    "addSocialAccount": "Add social account",
    "addMultiplePagesAccountsOrLocations": "Add multiple Pages, accounts, or locations per network under one login",
    "commentsCenter": "Comments Center",
    "replyAssignResolveAndConvertFacebook": "Reply, assign, resolve, and convert Facebook, Instagram, LinkedIn, X, and YouTube comments to CRM leads",
    "engagementTrends": "Engagement trends",
    "platformComparison": "Platform comparison",
    "responsePerformance": "Response performance",
    "crossChannelActivityOverTime": "Cross-channel activity over time",
    "engagementAndClicksByChannel": "Engagement and clicks by channel",
    "averageResponseTimeTrendMinutes": "Average response time trend (minutes)",
    "writtenForBusinessOwnersAndMarketing": "Written for business owners and marketing teams — no technical background required",
    "socialConnectionCenter": "Social Connection Center",
    "connected": "Connected",
    "avgHealth": "Avg health",
    "tokenIssues": "Token issues",
    "webhookIssues": "Webhook issues",
    "connectValidateAndMonitorEverySocial": "Connect, validate, and monitor every social channel — no developer knowledge required",
    "connectAccount": "Connect account",
    "resetConnection": "Reset",
    "resetConnectionTitle": "Reset setup form?",
    "resetConnectionMessage": "This will clear the setup wizard progress and remove saved app credentials for {{platform}}. Your already connected channels will not be disconnected.",
    "resetConnectionConfirm": "Reset",
    "resetSharedMetaCredentialsWarning": " Saved Meta app credentials will also be removed (shared with Facebook, Instagram, WhatsApp, and Threads). Connected channels stay linked.",
    "resetSharedGoogleCredentialsWarning": " Saved Google app credentials will also be removed (shared with YouTube and Google Business). Connected channels stay linked.",
    "crmLeadsFromSocial": "CRM Leads from Social",
    "leadsCreatedFromInboxCommentsReviews": "Leads created from inbox, comments, reviews, and intake automation",
    "socialCommandCenter": "Dashboard",
    "getStarted": "Get started",
    "getStartedDescription": "Connect Facebook, Instagram, WhatsApp, LinkedIn, and more — you can add multiple accounts per network.",
    "readSetupGuides": "Read setup guides",
    "addFirstAccount": "Add your first account",
    "publishingCenterLink": "Publishing Center →",
    "connected": "Connected",
    "notConnected": "Not connected",
    "areasCount": "{{count}} areas",
    "additionalMetrics": "Additional metrics",
    "comments": "Comments",
    "reviews": "Reviews",
    "leadsGenerated": "Leads generated",
    "publishedPosts": "Published posts",
    "channelHealth": "Channel health",
    "openComments": "Open comments",
    "todaySWork": "Today's work",
    "connectedPlatforms": "Connected platforms",
    "unifiedSocialInboxPublishingAndAnalytics": "Unified social inbox, publishing, and analytics for your connected accounts",
    "openADedicatedWorkspaceOnlySupported": "Open a dedicated workspace — only supported features appear",
    "refreshData": "Refresh data",
    "refreshingData": "Refreshing…",
    "dashboardChartsEmpty": "Activity will appear here as messages, posts, and comments come in.",
    "dashboardChannelsEmpty": "Connect channels to compare engagement across platforms.",
    "dashboardResponseEmpty": "Response time trends appear after team replies to conversations.",
    "unifiedInbox": "Unified Inbox",
    "allChannels": "All channels",
    "facebookInstagramWhatsappTelegramAndAll": "Facebook, Instagram, WhatsApp, Telegram, and all messaging-capable channels in one queue",
    "socialListening": "Social Listening",
    "brandKeywordAndHashtagMatchesAcross": "Brand, keyword, and hashtag matches across connected channels",
    "mediaLibrary": "Media Library",
    "imagesVideosAndCampaignAssetsOrganized": "Images, videos, and campaign assets — organized in folders with search and reuse in Publishing",
    "status": "Status",
    "publishing": "Publishing",
    "notAvailable": "Not available",
    "stories": "Stories",
    "reels": "Reels",
    "mentions": "Mentions",
    "publishingCenter": "Publishing Center",
    "composePost": "Compose post",
    "composeScheduleApproveAndPublishAcross": "Compose, schedule, approve, and publish across connected networks",
    "imagesOrVideoForThisPost": "Images or video for this post",
    "createPost": "Create post",
    "multiChannelPostsWithSchedulingMedia": "Multi-channel posts with scheduling, media, and provider delivery",
    "imagesVideoOrPdf": "Images, video, or PDF",
    "socialAnalytics": "Social Analytics",
    "followers": "Followers",
    "channelPerformanceMonitoringAndCsvExports": "Channel performance, monitoring, and CSV exports",
    "reviewsCenter": "Reviews Center",
    "totalReviews": "Total reviews",
    "open": "Open",
    "replied": "Replied",
    "avgRating": "Avg rating",
    "googleAndFacebookReviewsReplyAssign": "Google and Facebook reviews — reply, assign, track sentiment, and convert to CRM leads",
    "socialSettings": "Social Settings",
    "apiKeysWebhooksBrandsAndShortcuts": "API keys, webhooks, brands, and shortcuts to platform workspaces. Connect channels in Connection Center.",
    "socialSetup": "Social Setup",
    "platformCredentialsMultiBrandListeningAnd": "Platform credentials, multi-brand, listening, and competitor tracking",
    "socialTeams": "Social Teams",
    "assignConversationsAndModerateContentBy": "Assign conversations and moderate content by team member",
    "socialWebhooks": "Social webhooks",
    "configureMetaLinkedinAndOtherNetworks": "Configure Meta, LinkedIn, and other networks to POST inbound events",
    "connectPlatform": "Connect {{platform}}",
    "followEachStepToConnectChannel": "Follow each step to connect your channel.",
    "useConvertToLeadOnAnyMessage": "Use Convert to lead on any message, comment, or review. Attribution uses lead source"
  },
  "labels": {
    "ruleName": "Rule name",
    "campaignName": "Campaign name",
    "network": "Network",
    "displayName": "Display name",
    "accountIdOptional": "Account ID (optional)",
    "status": "Status",
    "assignTo": "Assign to",
    "assignAgent": "Assign agent…",
    "writeAPublicReply": "Write a public reply…",
    "simulateInboundDemo": "Simulate inbound (demo)",
    "recipientPhone": "Recipient phone (E.164, no +)",
    "recipientPhoneHint": "India: 919876543210 or 9876543210 (91 added automatically)",
    "message": "Message",
    "typeAReply": "Type a reply…",
    "teamOnlyNoteNotSentTo": "Team-only note (not sent to customer)…",
    "sectionTabs": "Section tabs",
    "publishing": "Publishing",
    "inboxDm": "Inbox / DM",
    "comments": "Comments",
    "reviews": "Reviews",
    "analytics": "Analytics",
    "crmIntegration": "CRM integration",
    "selectChannel": "Select channel",
    "addKeyword": "Add keyword",
    "newFolder": "New folder",
    "searchByNameOrTag": "Search by name or tag…",
    "title": "Title",
    "content": "Content",
    "schedule": "Schedule",
    "mediaAttachment": "Media attachment",
    "optionalMediaFile": "Optional media file",
    "scheduleOptional": "Schedule (optional)",
    "mediaOptional": "Media (optional)",
    "attachMediaToThisPost": "Attach media to this post",
    "simulateReviewDemo": "Simulate review (demo)",
    "reviewText": "Review text",
    "rating": "Rating",
    "writeAReply": "Write a reply…",
    "platform": "Platform",
    "appIdClientId": "App ID / Client ID",
    "appSecret": "App secret",
    "webhookVerifyToken": "Webhook verify token",
    "profileName": "Profile name",
    "brandName": "Brand name",
    "keywordOrHashtag": "Keyword or #hashtag",
    "newRule": "New rule",
    "allPlatforms": "All platforms",
    "active": "Active",
    "paused": "Paused",
    "slaBreached": "SLA breached",
    "internalNotes": "Internal notes",
    "conversationActions": "Conversation actions",
    "assignConversation": "Assign conversation",
    "addANote": "Add a note...",
    "tags": "Tags",
    "newTag": "New tag",
    "slaStatus": "SLA status",
    "due": "Due",
    "conversationBreachedSla": "This conversation has breached its SLA.",
    "platformIntegrationLiveOauth": "Platform integration (live OAuth)",
    "platformIntegrationDescription": "Each organization uses its own app credentials. Nothing is shared from server defaults. Save credentials here before connecting channels in the Connection Center.",
    "savedInDatabase": "Saved in database",
    "appId": "App ID",
    "webhookToken": "Webhook token",
    "wabaId": "WABA ID",
    "businessId": "Business ID",
    "botToken": "Bot token",
    "configured": "Configured",
    "updatedAt": "Updated {{date}}",
    "saved": "Saved",
    "leaveBlankToKeepExistingSecret": "Leave blank to keep existing secret",
    "whatsappBusinessAccountId": "WhatsApp Business Account ID (WABA)",
    "numericWabaIdFromMetaBusinessManager": "Numeric WABA ID from Meta Business Manager",
    "metaBusinessIdOptional": "Meta Business ID (optional)",
    "botTokenFromBotfather": "Bot Token (from BotFather)",
    "leaveBlankToKeepExistingToken": "Leave blank to keep existing token",
    "required": "required",
    "demo": "demo",
    "brands": "Brands",
    "listeningKeywords": "Listening keywords",
    "competitors": "Competitors",
    "followersCount_one": "{{count}} follower",
    "followersCount_other": "{{count}} followers",
    "done": "Done",
    "source": "Source",
    "score": "Score",
    "customer": "Customer",
    "all": "All",
    "resolved": "Resolved",
    "repliedWithText": "Replied: {{text}}",
    "type": "Type",
    "preview": "Preview",
    "matched": "Matched",
    "template": "Template",
    "body": "Body",
    "channels": "Channels",
    "teamMember": "Team member",
    "email": "Email",
    "role": "Role",
    "socialPermissions": "Social permissions",
    "time": "Time",
    "action": "Action",
    "detail": "Detail"
  },
  "formActions": {
    "save": "Save",
    "saveCredentials": "Save credentials",
    "saveDraftOrSchedule": "Save draft / schedule",
    "publishWithMedia": "Publish with media",
    "publishNow": "Publish now",
    "cancel": "Cancel",
    "close": "Close",
    "continue": "Continue",
    "back": "Back"
  },
  "listActions": {
    "newPost": "New post",
    "calendar": "Calendar",
    "openMediaLibrary": "Open Media Library",
    "trackCompetitor": "Track competitor",
    "sendTestMessage": "Send test message",
    "simulateWebhook": "Simulate webhook",
    "exportPosts": "Export posts",
    "exportInbox": "Export inbox",
    "refreshData": "Refresh data",
    "refreshToken": "Refresh token",
    "reconnectWizard": "Reconnect wizard",
    "readSetupGuide": "Read setup guide",
    "setupWizard": "Setup wizard",
    "startGuidedSetup": "Start guided setup",
    "openSetupWizard": "Open setup wizard",
    "checkConnectionHealth": "Check connection health",
    "openPublishingCenter": "Open Publishing Center",
    "addAccount": "Add account",
    "addAnotherAccount": "Add another account",
    "addAndConnect": "Add & connect",
    "compose": "Compose",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "escalate": "Escalate",
    "tag": "Tag",
    "assign": "Assign",
    "add": "Add",
    "create": "Create",
    "addRule": "Add rule",
    "pause": "Pause",
    "activate": "Activate",
    "delete": "Delete",
    "favorite": "Favorite",
    "unfavorite": "Unfavorite",
    "clear": "Clear",
    "apply": "Apply",
    "publish": "Publish",
    "retry": "Retry",
    "pickFromLibrary": "Pick from library",
    "openWorkspace": "Open workspace",
    "openInCrm": "Open in CRM",
    "fullCrm": "Full CRM →",
    "resolve": "Resolve",
    "addChannel": "Add channel",
    "refreshStatus": "Refresh status",
    "fix": "Fix →",
    "connectAPlatform": "Connect a platform",
    "previous": "Previous",
    "next": "Next",
    "refreshAccess": "Refresh access",
    "readGuide": "Read guide",
    "guidedReconnect": "Guided reconnect"
  },
  "empty": {
    "noNotesYet": "No notes yet.",
    "noSlaDeadline": "No SLA deadline set for this conversation.",
    "noAutomationRulesYet": "No automation rules yet.",
    "noBrandsEnterpriseMultiBrand": "No brands (Enterprise multi-brand)",
    "noKeywordsConfigured": "No keywords configured",
    "noCompetitorsTracked": "No competitors tracked",
    "noLogEntriesYet": "No log entries yet.",
    "noDrafts": "No drafts",
    "noPostsInQueue": "No posts in queue",
    "noSocialSourcedLeadsYet": "No social-sourced leads yet.",
    "noPostCommentsYet": "No post comments yet. They appear when webhooks sync or you simulate inbound engagement.",
    "noListeningMatchesYet": "No matches yet. Add keywords in Setup — matches appear as platforms sync or simulate inbound activity.",
    "noWhatsappTemplatesFound": "No templates found. Connect WhatsApp in Connection Center.",
    "noChannelsYet": "No channels yet.",
    "noAuditEntriesYet": "No audit entries yet."
  },
  "loading": {
    "rules": "Loading rules...",
    "comments": "Loading comments…"
  },
  "inbox": {
    "views": {
      "all": "Unified Inbox",
      "unread": "Unread",
      "assigned": "Assigned",
      "archived": "Archived"
    },
    "filters": {
      "title": "Filters",
      "filterConversations": "Filter conversations",
      "allStatuses": "All statuses"
    },
    "status": {
      "closed": "Closed"
    }
  },
  "publishing": {
    "tabs": {
      "compose": "Compose",
      "drafts": "Drafts",
      "queue": "Publish queue",
      "logs": "Publishing logs",
      "media": "Media library",
      "approvals": "Approvals"
    },
    "table": {
      "platforms": "Platforms"
    },
    "partialFallback": "Published to some channels only. Check Publishing logs and retry failed channels.",
    "mediaLibraryHint": "Upload and reuse images and videos in the dedicated Media Library.",
    "connectPublishingChannelsHint": "Connect publishing-capable channels in Settings. WhatsApp is inbox-only.",
    "mediaPreview": "Media preview",
    "platformSelection": "Platform selection",
    "scheduleHint": "Leave schedule empty to publish immediately. Set a date and time to queue the post.",
    "connectAtLeastOneChannel": "Connect at least one channel before publishing."
  },
  "workflow": {
    "title": "Workflow Builder",
    "description": "Design multi-step automations with triggers, conditions, and actions.",
    "viewRules": "View rules",
    "blocks": "Blocks",
    "workflowName": "Workflow name",
    "trigger": "Trigger",
    "action": "Action",
    "replyText": "Reply text",
    "canvasPreview": "Canvas preview",
    "triggers": {
      "inboundMessage": "Inbound message",
      "whatsappMessage": "WhatsApp message",
      "commentReceived": "Comment received"
    },
    "actions": {
      "autoReply": "Auto reply",
      "assignAgent": "Assign agent",
      "setPriority": "Set priority"
    }
  },
  "automation": {
    "triggers": {
      "inboundMessage": "Inbound message",
      "newComment": "New comment",
      "newReview": "New review",
      "negativeSentiment": "Negative sentiment"
    },
    "actions": {
      "autoReply": "Auto reply",
      "assignAgent": "Assign agent",
      "createCrmLead": "Create CRM lead",
      "escalate": "Escalate"
    }
  },
  "platformOptions": {
    "meta": "Meta (Facebook / Instagram / WhatsApp / Threads)",
    "google": "Google (YouTube + Google Business)",
    "linkedin": "LinkedIn",
    "twitter": "X (Twitter)",
    "tiktok": "TikTok",
    "telegram": "Telegram Bot",
    "pinterest": "Pinterest",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "whatsapp": "WhatsApp"
  },
  "platforms": {
    "whatsapp": {
      "templatesDescription": "Approved WhatsApp message templates synced from your connected WABA."
    }
  },
  "teams": {
    "permissionsSummary": "Inbox · Publish · Analytics (via org roles)",
    "assignmentHint": "Assignment is available in Unified Inbox and platform inboxes. Manage roles under Organization → Users."
  },
  "connection": {
    "tabs": {
      "connect": "Connect",
      "connectedChannels": "Connected Channels",
      "setupGuide": "Setup Guide",
      "connectionHealth": "Connection Health"
    },
    "activeAlerts": "Active alerts",
    "tokenStatus": "Token status",
    "valid": "Valid",
    "expiredOrMissing": "Expired / missing",
    "expires": "Expires",
    "refreshToken": "Refresh token",
    "present": "Present",
    "missing": "Missing",
    "scopes": "Scopes",
    "defaultDemo": "Default / demo",
    "runAllTests": "Run all tests",
    "runDiagnosticsEmpty": "Run diagnostics to see results.",
    "logsPageSummary": "Page {{page}} · {{count}} entries",
    "alertPreferences": "Alert preferences",
    "notifications": {
      "emailOnTokenExpiry": "Email when token expires or expiring soon",
      "emailOnWebhookFailure": "Email on webhook failure",
      "emailOnDisconnect": "Email when connection lost",
      "inAppAlerts": "In-app notifications"
    },
    "notificationDeliveryHint": "Email delivery uses your organization notification settings. In-app alerts appear on the Social dashboard.",
    "noActiveIssuesPrefix": "No active connection issues. For step-by-step fixes, open",
    "setupGuidesLink": "setup guides",
    "whatToDo": "What to do:",
    "oauth": "OAuth",
    "token": "Token",
    "webhook": "Webhook",
    "events24h": "Events 24h"
  },
  "settings": {
    "tabs": {
      "integrations": "Integrations",
      "webhooks": "Webhooks",
      "brands": "Brands",
      "platforms": "Platform workspaces",
      "advanced": "Advanced"
    },
    "platformWorkspace": "{{platform}} workspace →",
    "connectionNotifications": "Connection notifications",
    "notifications": {
      "emailOnTokenExpiry": "Email when token expires",
      "emailOnWebhookFailure": "Email on webhook failure",
      "emailOnDisconnect": "Email when connection lost",
      "inAppAlerts": "In-app alerts"
    },
    "diagnosticsAndLogs": "Diagnostics & logs",
    "runConnectionTestsAndViewLogs": "Run connection tests and view logs from Connection Center health view or channel actions.",
    "openConnectionHealth": "Open connection health",
    "outboundWebhooks": "Outbound webhooks",
    "configureOutboundEventSubscriptions": "Configure outbound event subscriptions via API or admin tools."
  }
}
